// extracted by mini-css-extract-plugin
export var body = "_pz-8";
export var button = "_pz-0";
export var closeButton = "_pz-5";
export var content = "_pz-3";
export var empty = "_pz-f";
export var grid = "_pz-c";
export var header = "_pz-4";
export var icon = "_pz-1";
export var option = "_pz-d";
export var optionSelected = "_pz-e";
export var overlay = "_pz-2";
export var searchIcon = "_pz-a";
export var searchInput = "_pz-b";
export var searchWrapper = "_pz-9";
export var title = "_pz-6";
export var visuallyHidden = "_pz-7";